<template>
  <el-drawer
    custom-class="detail-drawer"
    :append-to-body="true"
    :title="title"
    :visible.sync="drawer"
    :direction="direction"
    size="500px"
    :before-close="handleClose"
  >
    <div class="draw-content">
      <!-- ========天气详情 ========-->
      <!-- 城市 -->
      <div class="weather-item">
        <label>城市:</label>
        <span>{{ data.city }}</span>
      </div>
      <!-- 温度 -->
      <div class="weather-item">
        <label>温度:</label>
        <span>{{ data.temperature }}℃</span>
      </div>
      <!-- 湿度 -->
      <div class="weather-item">
        <label>湿度:</label>
        <span>{{ data.humidity }}%</span>
      </div>
      <!-- 天气 -->
      <div class="weather-item weather-item--weather">
        <label>天气:</label>
        <span class="weather-value">
          {{ data.weather }}
          <span class="weather-icon" :data-weather="data.weather"></span>
        </span>
      </div>
      <!-- 风力 -->
      <div class="weather-item">
        <label>风力:</label>
        <span>{{ data.windpower }}</span>
      </div>
      <!-- 数据时间 -->
      <div class="weather-item">
        <label>数据时间:</label>
        <span>{{ data.reporttime }}</span>
      </div>
      <!-- ========天气详情 ========-->
      <div class="table-container" v-loading="loading">
        <div class="forcast-table">
        <h3 class="sub-title">未来3天天气预报</h3>
          <!-- 预测天气的表格 -->
          <el-table :data="forecastList" size="mini">
            <el-table-column label="日期" prop="date"></el-table-column>
            <el-table-column label="天气" prop="dayweather">
              <template slot-scope="scope">
                <div class="weather-item_wrapper">
                  {{scope.row.dayweather}}
                  <span class="weather-icon" :data-weather="scope.row.dayweather"></span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="60" label="温度" prop="daytemp">
              <template slot-scope="scope">
                <div>
                  {{scope.row.daytemp}}℃
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 时段天气的表格 -->
        <div class="duration-table">
          <h3 class="sub-title">当日分时段天气</h3>
          <el-table 
            :data="analysis.durationData" size="mini">
            <el-table-column prop="hour" label="小时"></el-table-column>
            <el-table-column prop="weather" label="天气" width="100">
              <template slot-scope="scope">
                <div style="display:flex; align-items:center">
                  <span class="weather-icon" :data-weather="scope.row.weather"></span>
                  <span style="margin-left:5px;">{{scope.row.weather}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="temperature" label="温度" width="60"></el-table-column>
            <el-table-column prop="humidity" label="湿度" width="60"></el-table-column>
            <el-table-column prop="windpower" label="风力" width="60"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import Weather from "../model/Weather.js";
import Analysis from '../model/Analysis.js';

export default {
  name: "DetailDrawer",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: "rtl"
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      forecastList: [],
      durationList: [],
      loading: false,
      analysis: new Analysis(),
    };
  },
  methods: {
    handleClose(done) {
      this.$emit("close");
    },
    async getDurationData(adcode, date) {
      if (adcode && date) {
        let durationData = await this.analysis.fetchDurationData(adcode, date);
        this.analysis.setDurationData(durationData);
      }
    },
  },
  watch: {
    drawer: {
      immediate: true,
      handler: async function(visible) {
        if (visible) {
          const { time, adcode } = this.data;
          this.loading = true;
          const res = await Weather.fetchForecastData(time, adcode);
          await this.getDurationData(adcode, time);
          this.loading = false;
          if (res.length) {
            this.forecastList = res[0].casts;
          }
        }
      }
    }
  },
  computed: {
    title() {
      const city = this.data.city;
      return `${city}天气详情`;
    }
  }
};
</script>

<style lang="less">
@import url(../style/weather-icon.less);
* {
  &:focus {
    outline: none;
  }
}
.el-drawer {
  overflow-y: auto!important;
}
.detail-drawer {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: 2px 2px 20px rgba(255, 255, 255, 0.2) !important;
  .el-drawer__header > span {
    font-size: 18px;
  }
  .draw-content {
    padding: 20px;
  }
  .weather-item {
    font-size: 14px;
    line-height: 34px;
    color: #444;
    label {
      display: inline-block;
      width: 80px;
      padding-right: 20px;
      text-align: right;
    }
  }
  .weather-item--weather {
    display: flex;
    align-items: center;
    .weather-value {
      display: flex;
      align-items: center;
    }
  }
  .table-container {
    margin-top: 30px;
    padding: 0 20px;
    height: 100%;
    overflow-y: auto;
  }
  .weather-item_wrapper {
    display: flex;
    align-items: center;
  }
  .duration-table {
   margin-top: 30px; 
  }
  .sub-title {
    font-size: 16px;
    margin-bottom: 20px;
    color: #666;
    border-left: 4px solid #666;
    padding-left: 5px;
  }
}
</style>